import { Box, Typography } from "@material-ui/core"
import {
  BannerResponse,
  CategoryResponse,
  LeadBanner,
  getGiftCardGetBanners,
  getGiftCardGetCategory,
  getLeadLeadBanner,
  getSettingsGetQuickPurchaseSettings,
} from "api"
import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import HomePage from "components/Homepage/HomePage"
import KeyboardNavigation from "components/KeyboardNavigation/KeyboardNavigation"
import { GetStaticProps } from "next"
import { useState } from "react"

type HomeStaticProps = {
  banners: BannerResponse[]
  categories: CategoryResponse[]
  seo: SeoMetadataWithImage
  companiesBanner: LeadBanner
  settings: any
}

export const getStaticProps: GetStaticProps<HomeStaticProps> = async () => {
  const [banner, category, companiesBanner, settings] = await Promise.all([
    await getGiftCardGetBanners(),
    await getGiftCardGetCategory(),
    await getLeadLeadBanner(),
    // Default money value, and blessingId
    await getSettingsGetQuickPurchaseSettings(),
  ])

  const seo = {
    title: "גיפט קארד מקדונלד'ס | McDonald's giftcard",
    description:
      "הגיפט קארד של מקדונלד'ס ישראל. בואו להפתיע חברים ומשפחה. בוחרים עיצוב, סכום קניה, מקדישים ברכה וזהו..",
    keywords: "גיפט קארד מקדונלד'ס | McDonald's giftcard",
  }
  return {
    props: {
      banners: banner.data.body,
      categories: category.data.body,
      companiesBanner: companiesBanner.data.body,
      settings: settings.data.body,
      seo,
    },
    revalidate: 60,
  }
}

const Home = ({
  banners,
  categories,
  companiesBanner,
  settings,
  seo,
}: HomeStaticProps) => {
  const [refList, setRefList] = useState([])

  return (
    <>
      <KeyboardNavigation refList={refList} />
      <SeoMetaData data={seo} />
      <Box>
        <Typography variant="srOnly" component={"h1"}>
          מקדונלד&lsquo;s GiftCard{" "}
        </Typography>
        <HomePage
          banners={banners}
          setRefList={setRefList}
          categories={categories}
          companiesBanner={companiesBanner}
          settings={settings}
        />
      </Box>
    </>
  )
}

export default Home
